var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_15289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 98C196 43.8764 152.124 0 98 0C43.8764 0 0 43.8757 0 98C0 146.914 35.8374 187.458 82.6875 194.809V126.328H57.8047V98H82.6875V76.4094C82.6875 51.8481 97.3186 38.2812 119.703 38.2812C130.426 38.2812 141.641 40.1953 141.641 40.1953V64.3125H129.283C117.108 64.3125 113.312 71.8669 113.312 79.6173V98H140.492L136.147 126.328H113.312V194.809C160.163 187.458 196 146.915 196 98Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.147 126.328L140.492 98H113.312V79.6173C113.312 71.8662 117.109 64.3125 129.283 64.3125H141.641V40.1953C141.641 40.1953 130.426 38.2812 119.703 38.2812C97.3186 38.2812 82.6875 51.8481 82.6875 76.4094V98H57.8047V126.328H82.6875V194.809C87.753 195.603 92.8727 196.001 98 196C103.127 196.002 108.247 195.603 113.312 194.809V126.328H136.147Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_15289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.604df3a3a2c2bb33cc8f7c5ed8f534f7.svg";
export { ForwardRef as ReactComponent };